import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "../../../comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${ptlEnvs.base}/intf/enpo`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/intf/enpo`,
};

export const URLS = {
    osci0113004q: `${BASE.path}/osci0113004q`, // list
    osci0113005s: `${BASE.path}/osci0113005s`, // regist
    osci0113006s: `${BASE.path}/osci0113006s`, // modification
};

export const APIS = {
    // Get a list of Channel. !== 채널 목록을 조회한다.==!
    getIntfOrgEnpoList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get Channel details. !== 채널 상세정보 조회 ==!
    getIntfOrgEnpo: (orgEnpoId: any) => {
        return api.get(`${BASE.api}/${orgEnpoId}`);
    },
    // Insert Channel !== 채널 등록 ==!
    insertIntfOrgEnpo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update Channel !== 채널 수정 ==!
    updateIntfOrgEnpo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    deleteIntfOrgEnpo: (orgEnpoId: any) => api.delete(`${BASE.api}/${orgEnpoId}`),
};

export const SF_INTF_ORG_ENPO_MGMT: TFormSchema = {
    id: "form_intfOrgEnpoMgmtSrch",
    schema: {
        sndrcvDvnCd: {
            type: "radio",
            label: "L_SNDRCV_DVN_NM",
            area: "comnCd",
            comnCd: "OSC0109",
            excludes: ["C"],
            all: true,
            defaultValue: "",
        },
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd" },
        orgEnpoId: { type: "text", label: "L_ORG_ENPO_ID", maxLength: 100 },
        orgEnpoNm: { type: "text", label: "L_ORG_ENPO_NM" },
        // orgTin: {
        //     type: "text",
        //     label: "L_ORG_TIN",
        //     maxLength: 9,
        //     minLength: 7,
        //     pattern: { value: /[0-9]$/, message: "msg.osc.00188" },
        // },
        intfId: { type: "text", label: "L_INTF_ID" },
        govesbUseYn: {
            type: "radio",
            label: "L_GOVESB_USE_YN",
            area: "comnCd",
            comnCd: "OSC0101",
            all: true,
            defaultValue: "",
        },
    },
};

export const SG_INTF_ORG_ENPO_MGMT: TGridSchema = {
    id: "grid_intfOrgEnpoMgmtSrch",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_ORG_ENPO_ID", binding: "orgEnpoId", width: "15%" }] },
        { cells: [{ header: "L_ORG_ENPO_NM", binding: "orgEnpoNm", width: "15%" }] },
        { cells: [{ header: "L_ORG_CD", binding: "orgCd", width: "*" }] },
        // { cells: [{ header: "L_ORG_TIN", binding: "orgTin", width: "15%" }] },
        { cells: [{ header: "L_SNDRCV_DVN_NM", binding: "sndrcvDvnCd", width: 130 }] },
        { cells: [{ header: "L_ORG_ENPO_URL", binding: "orgUrlAddr", width: "*" }] },
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: 130 }] },
        { cells: [{ header: "L_GOVESB_USE_YN", binding: "govesbUseYn", width: 100 }] },
    ],
    body: [
        { cells: [{ binding: "orgEnpoId" }] },
        { cells: [{ binding: "orgEnpoNm", align: "left" }] },
        { cells: [{ binding: "orgCd", type: "select", area: "orgCd" }] },
        // { cells: [{ binding: "orgTin", align: "left" }] },
        { cells: [{ binding: "sndrcvDvnCd", type: "select", area: "comnCd", comnCd: "OSC0109" }] },
        { cells: [{ binding: "orgUrlAddr" }] },
        { cells: [{ binding: "intfId" }] },
        { cells: [{ binding: "govesbUseYn", type: "select", area: "comnCd", comnCd: "OSC0101" }] },
    ],
};

export const SF_INTF_ORG_ENPO_INFO: TFormSchema = {
    id: "form_intfOrgEnpoInfo",
    schema: {
        sndrcvDvnCd: {
            type: "radio",
            label: "L_SNDRCV_DVN_NM",
            area: "comnCd",
            comnCd: "OSC0109",
            required: true,
            excludes: ["C"],
        },
        orgEnpoId: { type: "text", label: "L_ORG_ENPO_ID", required: true, maxLength: 100 },
        orgEnpoNm: { type: "text", label: "L_ORG_ENPO_NM", required: true },
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", required: true },
        orgTin: {
            type: "text",
            label: "L_ORG_TIN",
            maxLength: 9,
            minLength: 7,
            pattern: { value: /[0-9]$/, message: "msg.osc.00188" },
            required: false,
        },
        orgIpAddr: { type: "text", label: "L_IP_ADDR" },
        orgPortNo: {
            type: "text",
            label: "L_PORT_VAL",
            maxLength: 10,
            pattern: { value: /[0-9]$/, message: "msg.osc.00188" },
        },
        orgUrlAddr: { type: "text", label: "L_ORG_ENPO_URL", required: true },

        govesbUseYn: {
            type: "radio",
            label: "L_GOVESB_USE_YN",
            area: "comnCd",
            comnCd: "OSC0101",
            defaultValue: "N",
        },
        apiCd: { type: "text", label: "L_API_CD" },
        pushCd: { type: "text", label: "L_PSH_CD" },

        tknTpCd: {
            type: "select",
            label: "L_IFAUTH_TP_CD",
            area: "comnCd",
            comnCd: "OSC0112",
            defaultValue: "N",
            required: true,
        },
        tknUrlAddr: { type: "text", label: "L_TKN_URL" },
        tknId: { type: "text", label: "L_TKN_ID" },
        tknPwd: { type: "text", label: "L_TKN_SECRT_KEY_VALUE" },
        tknCn: { type: "textarea", label: "L_TKN_CN" },

        signFileId: { type: "text", label: "L_SIGN_FILE_NM" },
        signKeyCn: { type: "textarea", label: "L_SIGN_KEY_CN" },

        rspnSignFileId: { type: "text", label: "L_ACK_SIGN_FILE_NM" },
        rspnSignKeyCn: { type: "textarea", label: "L_ACK_SIGN_KEY_CN" },

        intfId: { type: "text", label: "L_INTF_ID", required: true },

        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN" },
        chnlAplyPrcdStatCd: { type: "select", label: "L_PRCS_STTS", area: "comnCd", comnCd: "OSC0110", required: true },

        chnlPrtclNm: { type: "radio", label: "L_PRTCL_NM", area: "comnCd", comnCd: "OSC0105", required: true },
        actvtYn: {
            type: "radio",
            label: "L_ACTVT_YN",
            area: "comnCd",
            comnCd: "OSC0101",
            defaultValue: "Y",
            required: true,
        },
        cntyCd: { type: "code", label: "L_CNTY_CD", area: "cntyCd", popupSize: "md" },
        coCd: { type: "code", label: "L_CO_CD", area: "coDclaCd", popupSize: "md" },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        frstRgsrDtm: { type: "datetime", label: "L_FRST_RGSR_DTM" },
        gwayApiKey: { type: "textarea", label: "L_API_KEY" },
        gwayUrlAddr: { type: "text", label: "L_URL_ADDR" },

        cpaId: { type: "text", label: "L_CPA_ID" },
        cpaCntyCd: { type: "code", label: "L_CPA_CNTY", area: "cntyCd", popupSize: "md" },
        cpaSndrId: { type: "text", label: "L_CPA_SNDR_ID" },
        cpaSndrPwd: { type: "text", label: "L_CPA_SNDR_PWD" },
        cpaRcvrId: { type: "text", label: "L_CPA_RCVR_ID" },
        cpaRcvrPwd: { type: "text", label: "L_CPA_RCVR_PWD" },
        parnEnpo: { type: "text", label: "L_PARN_ENPO" },
        parnIp: { type: "text", label: "L_PARN_IP" },
        ovstCagYn: {
            type: "radio",
            label: "L_OVST_CAG_CHK",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            defaultValue: "N",
        },
        ipYn: {
            type: "radio",
            label: "L_IP_CHK",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            defaultValue: "N",
        },
        tansadBlckYn: {
            type: "radio",
            label: "L_TANSAD_BLCK",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            defaultValue: "N",
        },
    },
};

export const SG_TANCIS_ED_RCVR_INFO_LIST: TGridSchema = {
    id: "grid_docTrscList",
    options: { edit: false, checkbox: true },
    head: [
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: "*", required: true }] },
        { cells: [{ header: "L_INTF_NM", binding: "intfNm", width: "*", required: true }] },
        { cells: [{ header: "L_SNDRCV_TP_NM", binding: "sndrcvTpCd", width: "*", required: true }] },
        { cells: [{ header: "L_SNDR_ID", binding: "intfSndrId", width: "*", required: true }] },
        { cells: [{ header: "L_SNDR_NM", binding: "sndrNm", width: "*", required: true }] },
        { cells: [{ header: "L_RCVR_ID", binding: "intfRcvrId", width: "*", required: true }] },
        { cells: [{ header: "L_RCVR_NM", binding: "intfRcvrNm", width: "*", required: true }] },
        { cells: [{ header: "L_API_URL_ADDR", binding: "apiUrlAddr", width: "*", required: true }] },
    ],
    body: [
        { cells: [{ binding: "intfId", type: "text" }] },
        { cells: [{ binding: "intfNm", type: "text" }] },
        { cells: [{ binding: "sndrcvTpCd", type: "code", area: "comnCd", comnCd: "OSC0104", viewType: "label" }] },
        { cells: [{ binding: "intfSndrId", type: "text" }] },
        { cells: [{ binding: "sndrNm", type: "text" }] },
        { cells: [{ binding: "intfRcvrId", type: "text" }] },
        { cells: [{ binding: "rcvrNm", type: "text" }] },
        { cells: [{ binding: "apiUrlAddr", type: "text" }] },
    ],
};

export const SF_DOC_BOX_MGMT_SRCH: TFormSchema = {
    id: "form_docBoxMgmtSrch",
    schema: {
        /* Search keyword Select Option !== 검색어 목록 ==!*/
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_INTF_ID", value: "E" },
                { label: "L_INTF_NM", value: "A" },
                //{ label: "L_SNDR_NM", value: "B" },
                //{ label: "L_RECPT_NM", value: "C" },
                //{ label: "L_API_URL_ADDR", value: "D" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            readOnly: true,
        },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            all: true,
            area: "comnCd",
            comnCd: "OSC0088",
        },
        inexTpCd: {
            type: "select",
            label: "L_INEX_TP_NM",
            all: true,
            area: "comnCd",
            comnCd: "OSC0164",
        },
        actvtYn: {
            type: "select",
            label: "L_ACTVT_YN",
            area: "comnCd",
            comnCd: "OSC0101",
        },
    },
};
export const SG_DOC_BOX_MGMT_LIST: TGridSchema = {
    id: "grid_docBoxMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: "*" }] },
        { cells: [{ header: "L_INTF_NM", binding: "intfNm", width: "*" }] },
        { cells: [{ header: "L_SNDR_NM", binding: "sndrNm", width: "*" }] },
        { cells: [{ header: "L_RECPT_NM", binding: "rcvrNm", width: "*" }] },
        { cells: [{ header: "L_API_URL_ADDR", binding: "apiUrlAddr", width: "*" }] },
        { cells: [{ header: "L_INEX_TP_NM", binding: "inexTpCdNm", width: 100 }] },
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "*" }] },
        { cells: [{ header: "L_SNDRCV_TP_NM", binding: "sndrcvTpCdNm", width: 150 }] },
        { cells: [{ header: "L_ACTVT_YN", binding: "actvtYnNm", width: 80 }] },
    ],
    body: [
        { cells: [{ binding: "intfId" }] },
        { cells: [{ binding: "intfNm" }] },
        { cells: [{ binding: "sndrNm" }] },
        { cells: [{ binding: "rcvrNm" }] },
        { cells: [{ binding: "apiUrlAddr", align: "left" }] },
        { cells: [{ binding: "inexTpCdNm" }] },
        { cells: [{ binding: "bsopClsfCdNm" }] },
        { cells: [{ binding: "sndrcvTpCdNm" }] },
        { cells: [{ binding: "actvtYnNm" }] },
    ],
};
